import moment from "moment";

// Formato de moneda y fecha de PrestaPlus+. Replica el que ya usa la app en sus pantallas:
//   C$ -> new Intl.NumberFormat("es-NI", { style: "currency", currency: "NIO" })  (ej. C$1,234.50)
//   $  -> new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" })  (ej. $1,234.50, como en el pagaré)
//   fecha -> moment(...).format("L") con el idioma "es" (DD/MM/YYYY)
// Los formateadores se crean una sola vez: construir un Intl.NumberFormat es caro y las tablas
// formatean cientos de cifras.

const CORDOBAS = new Intl.NumberFormat("es-NI", { style: "currency", currency: "NIO" });
const DOLARES = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });

// "NIO" y "USD" son sinónimos de "C$" y "$".
const FORMATOS_MONEDA = { "C$": CORDOBAS, NIO: CORDOBAS, $: DOLARES, USD: DOLARES };

const SIN_DATO = "—";

/**
 * Da formato de moneda con 2 decimales y separador de miles.
 * @param {number|string} valor
 * @param {string} moneda "C$" o "NIO" (córdobas, por defecto); "$" o "USD" (dólares). Otro símbolo se antepone tal cual.
 * @returns {string} Ej.: formatearMonto(1234.5) -> "C$1,234.50". Sin dato numérico devuelve "—".
 */
export const formatearMonto = (valor, moneda = "C$") => {
  if (valor === null || valor === undefined || valor === "") return SIN_DATO;
  const numero = Number(valor);
  if (!Number.isFinite(numero)) return SIN_DATO;

  const formato = FORMATOS_MONEDA[moneda];
  if (formato) return formato.format(numero);

  // Símbolo no previsto: 2 decimales con miles al estilo de la app.
  return `${moneda}${numero.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

/**
 * Da formato de fecha DD/MM/YYYY (el "L" de moment en español que usa la app).
 * @param {Date|string|number} fecha
 * @returns {string} Ej.: formatearFecha("2026-09-30") -> "30/09/2026". Sin fecha válida devuelve "—".
 */
export const formatearFecha = (fecha) => {
  if (fecha === null || fecha === undefined || fecha === "") return SIN_DATO;
  const m = moment(fecha);
  return m.isValid() ? m.format("DD/MM/YYYY") : SIN_DATO;
};

/**
 * Da formato de fecha y hora DD/MM/YYYY hh:mm A (12 horas con AM/PM).
 * @param {Date|string|number} fecha
 * @returns {string} Ej.: formatearFechaHora("2026-09-30T14:30:00") -> "30/09/2026 02:30 PM". Sin fecha válida devuelve "—".
 */
export const formatearFechaHora = (fecha) => {
  if (fecha === null || fecha === undefined || fecha === "") return SIN_DATO;
  const m = moment(fecha);
  return m.isValid() ? m.format("DD/MM/YYYY hh:mm A") : SIN_DATO;
};
